import { API_ROUTES } from "../config";
import { http } from "../http";

// ─── Floor Layouts ────────────────────────────────────────────────────────────

export const getFloorLayoutsService = async () => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-floor-layouts"]);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createFloorLayoutService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-floor-layouts"], data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const getFloorLayoutByIdService = async (id) => {
    console.log("Fetching floor layout with ID:", id);
    try {
        const responseData = await http().get(`${API_ROUTES["seat-management-floor-layouts"]}/${id}`);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const updateFloorLayoutService = async (id, data) => {
    try {
        const responseData = await http().put(`${API_ROUTES["seat-management-floor-layouts"]}/${id}`, data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const deleteFloorLayoutService = async (id) => {
    try {
        const responseData = await http().delete(`${API_ROUTES["seat-management-floor-layouts"]}/${id}`);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

// ─── Sections ─────────────────────────────────────────────────────────────────

export const getSectionsService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-sections"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createSectionService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-sections"], data);
        
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const updateSectionService = async (id, data) => {
    try {
        const responseData = await http().put(`${API_ROUTES["seat-management-sections"]}/${id}`, data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const deleteSectionService = async (id) => {
    try {
        const responseData = await http().delete(`${API_ROUTES["seat-management-sections"]}/${id}`);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

// ─── Seats ────────────────────────────────────────────────────────────────────

export const getSeatsService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-seats"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createSeatService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-seats"], data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const searchSeatsService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-seats-search"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const updateSeatService = async (id, data) => {
    try {
        const responseData = await http().put(`${API_ROUTES["seat-management-seats"]}/${id}`, data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const deleteSeatService = async (id) => {
    try {
        const responseData = await http().delete(`${API_ROUTES["seat-management-seats"]}/${id}`);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const getSeatDetailsService = async (id) => {
    try {
        const responseData = await http().get(`${API_ROUTES["seat-management-seats"]}`, {
            params: { seat_id: id }
        });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const assignPermanentSeatService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-assign-permanent"], data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const cancelPermanentBookingService = async (id) => {
    try {
        const responseData = await http().delete(`${API_ROUTES["seat-management-assign-permanent"]}/${id}`);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

// ─── Bookings ─────────────────────────────────────────────────────────────────

export const getBookingsService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-bookings"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createBookingService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-bookings"], data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createAdminSingleDayBookingService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-admin-single-day-booking"], data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createAdminDateRangeBookingService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-admin-date-range-booking"], data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const getBookingsBySectionService = async (sectionId, params) => {
    try {
        const responseData = await http().get(`${API_ROUTES["seat-management-bookings"]}/section/${sectionId}`, { params });

        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const cancelBookingService = async (id, data) => {
    try {
        const responseData = await http().put(`${API_ROUTES["seat-management-bookings"]}/${id}/cancel`, data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createRecurringBookingService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-recurring-bookings"], data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const getSeatBlocksService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-blocks"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createSeatBlockService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-blocks"], data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const getSeatBlockService = async (id) => {
    try {
        const responseData = await http().get(`${API_ROUTES["seat-management-blocks"]}/${id}`);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const updateSeatBlockService = async (id, data) => {
    try {
        const responseData = await http().put(`${API_ROUTES["seat-management-blocks"]}/${id}`, data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createRecurringSeatBlockService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-blocks-recurring"], data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createPermanentSeatBlockService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-blocks-permanent"], data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const cancelSeatBlockService = async (id, data) => {
    try {
        const responseData = await http().put(`${API_ROUTES["seat-management-blocks"]}/${id}/cancel`, data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const cancelRecurringSeatBlockService = async (id, data) => {
    try {
        const responseData = await http().delete(`${API_ROUTES["seat-management-blocks-recurring"]}/${id}`, { data });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const cancelPermanentSeatBlockService = async (id, data) => {
    try {
        const responseData = await http().delete(`${API_ROUTES["seat-management-blocks-permanent"]}/${id}`, { data });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const getAllAdminSeatBlocksService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-blocks-admin-all"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const getRecurringBookingService = async (id) => {
    try {
        const responseData = await http().get(`${API_ROUTES["seat-management-bookings"]}/recurring/${id}`);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const cancelRecurringBookingService = async (id) => {
    try {
        const responseData = await http().delete(`${API_ROUTES["seat-management-recurring-bookings"]}/${id}`);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

// ─── Users ────────────────────────────────────────────────────────────────────

export const getAllUsersService = async () => {
    try {
        const responseData = await http().get(API_ROUTES["all-members-only"]);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const getAllAdminBookingsService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-bookings-admin-all"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const getBookingActivitySummaryService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-booking-activity-summary"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const getBookingActivityLogsService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-booking-activity-logs"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};
